import { FREE_TEXT_SEARCH_QUERY_SUBMITTED_LABEL as t, QUERY_SUBMITTED_EVENT_NAME as T } from "./help-center-articles-search22.js";
function a(E, e) {
  return {
    eventName: T,
    data: {
      query: E,
      location: e,
      searchTerm: E,
      label: t,
      position: "0"
    }
  };
}
export {
  a as getQuerySubmittedEventData
};
//# sourceMappingURL=help-center-articles-search14.js.map
